define([
    "./monitoringNodeCommandsModule",
    "./monitoringCommonNodeCommands"
], function () {
});